// removed by extract-text-webpack-plugin
module.exports = {"donutSpinnerWrapper":"_7P_vvnHEnie9CNs85UBsn","donutSpinner":"_3RRQrA880X2iz1I4bGX-9R","donut-spin":"_tAGPt2g3NuWgpAC36Pmn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DonutSpinner/DonutSpinner.css
// module id = 476
// module chunks = 8